/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('.owl-carousel.testimonial-slider').owlCarousel({
    loop:true,
    nav:true,
    dots:true,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:false,
      },
      640:{
        items:1,
        dots:false
      },
      1000:{
        items:1,
        dots:false
      }
    }
  })

  $('.owl-carousel.how-to-use-slider').owlCarousel({
    loop:false,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        loop:false,
        nav:true
      },
      600:{
        items:2,
        loop:false,
        nav:true
      },
      1000:{
        items:3.2,
        nav:true       
      },
       1440:{
        items:4,
        nav:true       
      }
    }
  })

  $('.owl-carousel.product_ingredients').owlCarousel({
    loop:false,
    margin:10,
    responsiveClass:true,
    responsive:{
      0:{
        items:2,
        center:true,
        loop:false,
        nav:true
      },
      600:{
        items:2,
        loop:false,
        nav:false
      },
      1000:{
        items:3,
        nav:true,
        loop:false
      }
    }
  })

  $(".myFilters li").click(function () {
    $(".myFilters li").removeClass("active");
    // $(".tab").addClass("active"); // instead of this do the below 
    $(this).addClass("active");   
  });
  
  $(".cartIcon .collection_Addtocart").on('click' , function(e){
    e.preventDefault();
    console.log("collection add to cart call");
     var Id = $(this).val();
    console.log(Id);
    var qty = 1;
	collection_addtocart(Id,qty)
    
   });
  function collection_addtocart(variant_id,quantity){
 	 data = {
      "id":variant_id,
      "quantity": quantity
    }
     $.ajax({
       type: 'POST',
       url: '/cart/add.js',
       data: data,
       dataType: 'json',
       success: function(data) {
         console.log(data);
         document.documentElement.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
           detail: {
             variant: data.id,
             quantity: data.quantity
           }
         }));
       }   
     }); 
  }
  
});